/**
 * Styled Components - Created by cazarez on 28/02/18.
 */
import styled from 'styled-components'
import Divider from 'antd/lib/divider'

export const Container = styled.div`
  margin-bottom: 15px;
`

export const Content = styled.div`
  display: flex;
  flex-flow: column;
  max-width: 240px;
  .ant-checkbox-wrapper:hover .ant-checkbox-inner {
    border: 1px solid #373737;
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    border-color: #373737;
    background-color: #373737;
  }
`
export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding-right: 10px;
  &:hover {
    cursor: pointer;
  }
`
export const Title = styled.div`
  height: 22.74px;
  color: #5f6062;
  font-size: 16px;
  font-weight: 600;
  line-height: 23px;
`

export const StyledDivider = styled(Divider)`
  margin: 10px 0 5px;
`

export const ItemRow = styled.div`
  margin-bottom: 5px;
`
export const AnimateHeightStyled = {
  width: '200px'
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/ProductCatalogFilterComponent/styledComponents.tsx